import { LocalLogin } from ':support/components/LocalLogin';
import { getStaticConfig, isLocal } from ':support/config';

export type TargetEnv = 'production' | 'staging' | 'development' | 'local';

export function UnauthenticatedApp() {
  if (isLocal()) {
    return <LocalLogin />;
  }

  // redirect to login page
  const { loginURL } = getStaticConfig();
  window.location.assign(loginURL);
  return null;
}
